export default __webpack_public_path__ + "static/media/northwestern-white.4ae8bdd2.png";